import React, { useMemo } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Client } from 'boardgame.io/react';
import { SocketIO } from '../lib/multiplayer';
import { Buzzer } from '../lib/store';
import { GAME_SERVER } from '../lib/endpoints';
import Table from '../components/Table';
import Header from '../components/Header';

function LoadingScreen() {
  return (
    <div>
      <Header />
      <Container className="container-loading">
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
        <p className="hint center-hint" style={{ marginTop: 16 }}>
          Xonaga ulanilmoqda…
        </p>
      </Container>
    </div>
  );
}

// Create once — remounting Client every render drops sync (incl. Yakunlash)
const BuzzerClient = Client({
  game: Buzzer,
  board: Table,
  multiplayer: SocketIO({ server: GAME_SERVER }),
  debug: false,
  loading: LoadingScreen,
});

export default function Game({ auth, setAuth, resetAuth }) {
  const { id: roomID } = useParams();
  const upper = String(roomID || '').toUpperCase();

  const headerData = useMemo(
    () => ({ ...auth, setAuth, resetAuth }),
    [auth, setAuth, resetAuth]
  );

  return (
    <main id="game">
      <div className="primary">
        <BuzzerClient
          key={`${upper}-${auth.playerID}`}
          gameID={upper}
          playerID={String(auth.playerID)}
          credentials={auth.credentials}
          headerData={headerData}
        />
      </div>
    </main>
  );
}
